/* eslint eqeqeq: off */
import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group from "../../../Components/Group";
import './index.css';
import Grid, {gridDateTime} from "../../../Components/Grid";
import {ModalAction} from "../../../Components/Modal";
import Resource from "../../../Resource";
import {Tool} from "../../../App";
import {connect} from "react-redux";
import ModalComplication from "../../Modal/ModalComplication";
import {OrgComplication} from '../../../Server/Complication';
import Perms from '../../../Perms';

class PageOrgComplications extends Component {
    constructor(props) {
        super(props);
        props.refer.current = this;


        if (!Perms().ORG_COMPLICATIONS.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            grid: {
                columnDefs: [{
                    headerName: 'اطلاعات بیمار',
                    headerTooltip: 'اطلاعات بیمار',
                    children: [{
                        field: 'patientFileCode',
                        headerName: 'شماره پرونده',
                        headerTooltip: 'شماره پرونده',
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        filter: 'agTextColumnFilter'
                    }, {
                        field: 'patientFullName',
                        headerName: 'نام بیمار',
                        headerTooltip: 'نام بیمار',
                        cellRenderer: row => `${row.data.patientFirstName} ${row.data.patientLastName}`
                    }, {
                        field: 'patientNationalCode',
                        headerName: 'کد‌ملی',
                        headerTooltip: 'کد‌ملی'
                    }, {
                        field: 'patientBloodGroupStr',
                        headerName: 'BGRh بیمار',
                        headerTooltip: 'BGRh بیمار',
                        cellRenderer: row => row.data.patientBloodGroupStr || '-',
                        cellClass: row => row.data.productBloodGroupId !== row.data.patientBloodGroupId ? 'red' : 'green'
                    }, {
                        field: 'patientBirthDate',
                        headerName: 'تاریخ تولد بیمار',
                        headerTooltip: 'تاریخ تولد بیمار',
                        hide: true,
                        cellRenderer: row => row.data.patientBirthDate || '-'
                    }]
                }, {
                    headerName: 'اطلاعات فرآورده',
                    children: [{
                        field: 'productNumber',
                        headerName: 'شماره فرآورده',
                        headerTooltip: 'شماره فرآورده',
                        filter: 'agTextColumnFilter'
                    }, {
                        field: 'productBloodGroupStr',
                        headerName: 'BGRH فرآورده',
                        headerTooltip: 'BGRH فرآورده',
                        cellRenderer: row => row.data.productBloodGroupStr || '-',
                        cellClass: row => row.data.productBloodGroupId !== row.data.patientBloodGroupId ? 'red' : 'green'
                    }, {
                        field: 'productTypeStr',
                        headerName: 'نوع فرآورده',
                        headerTooltip: 'نوع فرآورده',
                        cellRenderer: row => row.data.productTypeStr || '-'
                    }]
                }, {
                    headerName: 'اطلاعات تزریق',
                    headerTooltip: 'اطلاعات تزریق',
                    children: [{
                        field: 'consumptionDateTime',
                        headerName: 'زمان تزریق',
                        headerTooltip: 'زمان تزریق',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime
                    },]
                }, {
                    field: 'complicatedDateTime',
                    headerName: 'زمان ثبت',
                    headerTooltip: 'زمان ثبت',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime
                    // }, {
                    //     headerName: 'عملیات',
                    //     headerTooltip: 'عملیات',
                    //     pinned: props.gridDefaultSettings.pinOperationColumn,
                    //     sortable: false,
                    //     filter: false,
                    //     minWidth: 158,
                    //    // hide: !(Perms().SECTION_COMPLICATIONS.UPDATE || Perms().SECTION_COMPLICATIONS.DELETE),
                    // enableRowGroup: false,
                    // cellRenderer: 'control'
                }],
                // frameworkComponents: {
                //     control: row => {
                //         return <GridControls>
                //         </GridControls>;
                //     }
                // },
                getContextMenuItems: params => {
                    if (params.node) {
                        return [//{
                            // name: 'ویرایش فرم ثبت عارضه',
                            // icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EDIT1.BLACK}" alt="">`,
                            // action: this.update.bind(this, params.node.data),
                            // disabled: !Perms().SECTION_COMPLICATIONS.UPDATE
                            // }, {
                            //     name: 'حذف ثبت عارضه',
                            //     icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.TRASH1.BLACK}" alt="">`,
                            //     action: this.del.bind(this, params.node.data),
                            //     disabled: !Perms().SECTION_COMPLICATIONS.DELETE
                            // },
                            'separator',
                            ...params.defaultItems];
                    }
                },
                onRowDoubleClicked: row => {
                    this.ref.modalComplication.current.open(row.data, ModalAction.VIEW);
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre mar-b-4'}>نشان دهنده گروه خونی بیمار می باشد.</p>
                                <p className={'help-back-red mar-b-4'}>نشان دهنده مغایرت در گروه خونی فرآورده و بیمار می باشد.</p>
                            </div>
                        </div>
                    </div>;
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null
        };

        this.ref = {
            grid: React.createRef(),
            print: React.createRef(),
            modalComplication: React.createRef()
        };
    }

    componentDidMount() {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <React.Fragment>
            <Group className={'PageOrgComplications-group mar-10'} title={'عوارض ثبت شده'} description={'لیست عوارض ثبت شده از این قسمت قابل مشاهده می باشد.'}>
                <Grid  refer={this.ref.grid} id={'injectionComplications'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
            </Group>
            <ModalComplication refer={this.ref.modalComplication}/>
        </React.Fragment>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        OrgComplication.list()
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.grid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    view(row) {
        this.ref.modalComplication.current.open(row, ModalAction.VIEW);
    }
}

const
    mapStateToProps = state => {
        return {
            user: state.user,
            gridDefaultSettings: state.grid.defaultSettings
        };
    };

export default connect(mapStateToProps)(PageOrgComplications);